// vendor
import './axios'
import './bootstrap'
import './bxslider'
import './datejs'
import './enquirejs'
import './font-awesome'
import './leaflet'
import './lightslider'
import './jquery'
import './jquery-ui'
import './parsleyjs'
import './spinner'

// app
import './error-handler'
import './ie-fixed'
import './loading'
import './toastr'

import Vue from 'vue'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'
import Guards from './guards'
import Interceptors from './interceptors'

sync(store, router)
Vue.use(Guards, store, router)
Vue.use(Interceptors, store, router)

export { store, router }



// WEBPACK FOOTER //
// ./src/configs/index.js